/** By default, reCaptcha's siteKey of portkey is used, if it is a self-built service, please use your own siteKey */
export const defaultReCaptchaSiteKey = '6LfR_bElAAAAAJSOBuxle4dCFaciuu9zfxRQfQC0';
